import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import LoginDefaults from '../../login-defaults';

const axiosConfig = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

const isCpsApiRequest = (config) => {
  const apiUrl = new URL(axiosConfig.defaults.baseURL || '/', window.location.origin);
  const requestUrl = new URL(axiosConfig.getUri(config), window.location.origin);
  return requestUrl.origin === apiUrl.origin;
};

// Attach a fresh Cognito idToken only to CPS API requests. fetchAuthSession() automatically
// refreshes the token when it has expired (using the refresh token), which prevents the
// "Network Error" that appears once the ~1h idToken lifetime elapses after inactivity.
axiosConfig.interceptors.request.use(async (config) => {
  if (!isCpsApiRequest(config)) {
    config.headers.delete('Authorization');
    return config;
  }
  // Local dev uses a manually configured token and has no Amplify session.
  if (LoginDefaults && LoginDefaults.samlCheckDisabled) {
    return config;
  }
  try {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();
    if (idToken) {
      config.headers.Authorization = idToken;
    }
  } catch (err) {
    // No valid session (e.g., refresh token expired) — leave the existing header so the
    // response interceptor can route the resulting auth failure to session-expired.
  }
  return config;
});

axiosConfig.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && error.config && isCpsApiRequest(error.config)) {
      // Avoid redirect loop if already on session-expired page
      if (window.location.pathname !== '/session-expired') {
        localStorage.setItem('logged-out', 'true');
        window.location.replace('/session-expired');
      }
    }
    return Promise.reject(error);
  }
);

export default axiosConfig;
